import { defaultFetch } from './baseApi';

export const reopenStatements = (projectId: string, statementId: string) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}/reopen`;
	return defaultFetch(url, { method: 'POST' });
};
